// extracted by mini-css-extract-plugin
export default {"label":"styles_label__aqBym","oderPriceTotal":"styles_oderPriceTotal__lkSs7"};